(() => {
  'use strict';
  class DMFilm extends HTMLElement {
    connectedCallback() {
      if (this.ready) return;
      this.ready = true; this.abort = new AbortController();
      this.video = this.querySelector('video'); this.playButton = this.querySelector('[data-film-play]'); this.soundButton = this.querySelector('[data-film-sound]');
      this.reduced = matchMedia('(prefers-reduced-motion: reduce)');
      this.inView = false; this.userPaused = false; this.userStarted = false; this.loaded = false;
      this.video.muted = true;
      this.video.controls = false;
      const on={signal:this.abort.signal};
      this.playButton.addEventListener('click', () => {
        this.load();
        if (this.video.paused) { this.userPaused=false; this.userStarted=true; this.play(); }
        else { this.userPaused=true; this.video.pause(); }
      }, on);
      this.soundButton.addEventListener('click', () => {
        this.load(); this.userStarted=true; this.userPaused=false;
        this.video.muted = !this.video.muted;
        this.soundButton.textContent=this.video.muted?window.DM.ui.sf3113e55eb41:window.DM.ui.s0cd788249064;
        this.soundButton.setAttribute('aria-pressed',String(!this.video.muted));
        if(this.video.paused)this.play();
      }, on);
      this.querySelector('[data-film-fullscreen]').addEventListener('click', async () => {
        this.load();this.userStarted=true;
        try { if (this.video.webkitEnterFullscreen) this.video.webkitEnterFullscreen(); else await this.requestFullscreen(); } catch { this.video.controls=true; }
      }, on);
      const state=()=>{this.playButton.innerHTML=this.video.paused?window.DM.ui.playMarkup:'Pause <span aria-hidden="true">Ⅱ</span>';this.playButton.setAttribute('aria-label',this.video.paused?window.DM.ui.s0a2240e471a1:window.DM.ui.se27604eedd6d);};
      this.video.addEventListener('play',state,on);this.video.addEventListener('pause',state,on);
      this.observer = new IntersectionObserver(entries => { this.inView = entries[0].intersectionRatio >= .35; this.sync(); }, {threshold:[0,.35,.7]});
      this.observer.observe(this);
      document.addEventListener('visibilitychange',()=>this.sync(),on);
      this.reduced.addEventListener('change',()=>this.sync(),on);
      this.video.addEventListener('error',()=>{this.loaded=false;this.userPaused=true;this.playButton.textContent=window.DM.ui.sdda51ea50736;},on);
    }
    load() {
      if(this.loaded)return;
      this.loaded=true;
      this.video.querySelectorAll('source').forEach(source=>{source.src=source.dataset.src;});
      this.video.load();
    }
    play() { const promise=this.video.play(); if(promise)promise.catch(()=>{this.playButton.textContent=window.DM.ui.s332689878a12;}); }
    sync() {
      if(!this.inView||document.hidden){this.video.pause();return;}
      if(this.userPaused)return;
      if((this.reduced.matches||navigator.connection?.saveData)&&!this.userStarted){this.video.pause();return;}
      this.load();this.play();
    }
    disconnectedCallback() { this.observer?.disconnect(); this.abort?.abort();this.video?.pause();this.ready=false; }
  }
  if(!customElements.get('dm-film'))customElements.define('dm-film',DMFilm);
})();
